export type AccountTabKey =
    | 'personal'
    | 'activeSessions'
    | 'bank'
    | 'nominees'
    | 'demat'
    | 'segments'
    | 'funds'
    | 'practiceTrade'

export interface AccountTabConfig {
    key: AccountTabKey
    routeSlug: AccountTabSlug
    label: string
    sidebarSubtitle: string
    contentSubtitle: string
    requiresAccount: boolean
}

export type AccountTabSlug =
    | 'personal'
    | 'active-sessions'
    | 'bank'
    | 'nominee'
    | 'demat'
    | 'segments'
    | 'funds'
    | 'practice-trade'

export const ACCOUNT_TAB_CONFIG: AccountTabConfig[] = [
    {
        key: 'personal',
        routeSlug: 'personal',
        label: 'Personal',
        sidebarSubtitle: 'Your basic profile details',
        contentSubtitle: 'Your basic profile and account details',
        requiresAccount: false
    },
    {
        key: 'bank',
        routeSlug: 'bank',
        label: 'Bank',
        sidebarSubtitle: 'Linked bank accounts',
        contentSubtitle: 'Manage linked bank accounts for payouts and settlements. Account numbers are masked after saving.',
        requiresAccount: true
    },
    {
        key: 'nominees',
        routeSlug: 'nominee',
        label: 'Nominees',
        sidebarSubtitle: 'Manage your nominees',
        contentSubtitle: 'Add or update nominees. Changes are submitted for admin approval.',
        requiresAccount: true
    },
    {
        key: 'demat',
        routeSlug: 'demat',
        label: 'Demat',
        sidebarSubtitle: 'Demat account settings',
        contentSubtitle: 'View and manage demat account details',
        requiresAccount: true
    },
    {
        key: 'segments',
        routeSlug: 'segments',
        label: 'Segments',
        sidebarSubtitle: 'Activated trading segments',
        contentSubtitle: 'View and manage activated trading segments',
        requiresAccount: true
    },
    {
        key: 'funds',
        routeSlug: 'funds',
        label: 'Funds',
        sidebarSubtitle: 'Manage your funds',
        contentSubtitle: 'Add, withdraw, and view your fund history',
        requiresAccount: false
    },
    {
        key: 'activeSessions',
        routeSlug: 'active-sessions',
        label: 'Active sessions',
        sidebarSubtitle: 'Devices logged into your account',
        contentSubtitle: 'Review devices where you are signed in and log out sessions you no longer use.',
        requiresAccount: false
    },
    {
        key: 'practiceTrade',
        routeSlug: 'practice-trade',
        label: 'Practice Trade',
        sidebarSubtitle: 'Practice Trade account',
        contentSubtitle: 'View Practice Trade margin and reset your Practice Trade account',
        requiresAccount: false
    }
]

export const getAccountTabConfig = (key: AccountTabKey) =>
    ACCOUNT_TAB_CONFIG.find((tab) => tab.key === key)
